import { Typography } from "@vintecc/components";
import { type StackFrame } from "./stackTraceUtils";
import { StackFrameItem } from "./StackFrameItem";
import { CommonPluralTranslationKey, CommonTranslationKey, useCommonTranslation } from "@/services/culture/common.translations";

export type { StackFrame };

interface StackTraceViewerProps {
  frames: StackFrame[];
  title: string;
}

export const StackTraceViewer = ({ frames, title }: StackTraceViewerProps) => {
  const { t: translateCommon } = useCommonTranslation();
  const t = (key: Exclude<CommonTranslationKey, CommonPluralTranslationKey>) => translateCommon(key);

  if (frames.length === 0) {
    return null;
  }

  return (
    <div>
      <Typography variant="small-p" className="mb-3 font-semibold text-gray-700">
        {title} ({frames.length} {t("errors.framesSuffix")})
      </Typography>
      <ul className="border border-gray-200 rounded bg-white overflow-hidden max-h-80 overflow-y-auto">
        {frames.map((frame, idx) => (
          <StackFrameItem key={idx} frame={frame} index={idx} />
        ))}
      </ul>
    </div>
  );
};
